import { useEffect, useRef } from 'react';

const useTrapFocus = (isOpen: boolean, closeTrap: () => void) => {
    const focusRef = useRef();
    useEffect(() => {
        if (isOpen) {
            const trap: HTMLElement | null = focusRef.current;
            const focusableElements: NodeListOf<HTMLElement> | null =
                trap?.querySelectorAll(
                    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
                );

            const firstElement = focusableElements[0];
            const lastElement = focusableElements[focusableElements.length - 1];

            const handleTabKeyPress = (event: KeyboardEvent) => {
                if (event.key === 'Tab') {
                    if (
                        event.shiftKey &&
                        document.activeElement === firstElement
                    ) {
                        closeTrap();
                    } else if (
                        !event.shiftKey &&
                        document.activeElement === lastElement
                    ) {
                        closeTrap();
                    }
                }
            };

            const handleEscapeKeyPress = (event: KeyboardEvent) => {
                if (event.key === 'Escape') {
                    closeTrap();
                }
            };

            trap.addEventListener('keydown', event => handleTabKeyPress(event));
            trap.addEventListener('keydown', event =>
                handleEscapeKeyPress(event)
            );

            return () => {
                trap.removeEventListener('keydown', event =>
                    handleTabKeyPress(event)
                );
                trap.removeEventListener('keydown', event =>
                    handleEscapeKeyPress(event)
                );
            };
        }
    }, [isOpen]);
    return focusRef;
};

export default useTrapFocus;
